// KV の文字部分とそれより下の要素を、画面に入ったタイミングで下からふわっと表示する。
// 入れ子で二重にアニメーションしないよう、対象は「まとまり」単位で指定する。
const TARGETS = [
  '.p-kv__date',
  '.p-kv__venue',
  '.p-kv__title',
  '.p-kv__time',
  '.p-kv__cta',
  '.l-main .c-heading',
  '.p-section__inner > .p-text',
  '.p-section__btn:not(.p-special__btn)',
  '.p-areamap__map',
  '.p-areamap__nav',
  '.p-goods__menu',
  '.p-cd__jacket',
  '.p-cd__info',
  '.p-fanclub__subtitle',
  '.p-media',
  '.p-special__card',
  '.l-footer__links',
  '.l-footer .c-sns',
  // ロゴと©表記はページ最下部で判定範囲に入りきらないため、まとめて対象にする
  '.l-footer__bottom',
].join(',');

// 同時に画面に入った要素を少しずつずらして表示する間隔
const STAGGER_S = 0.12;

export const LOADED_EVENT = 'budokan:loaded';

function observe(elements) {
  const observer = new IntersectionObserver(
    (entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

      visible.forEach((entry, index) => {
        const el = entry.target;
        el.style.transitionDelay = `${index * STAGGER_S}s`;
        el.classList.add('is-revealed');
        observer.unobserve(el);
        // 表示し終えたらクラスを外し、要素本来の transition（ホバー等）に戻す
        const onEnd = (event) => {
          if (event.target !== el || event.propertyName !== 'transform') {
            return;
          }
          el.removeEventListener('transitionend', onEnd);
          el.style.transitionDelay = '';
          el.classList.remove('c-reveal', 'is-revealed');
        };
        el.addEventListener('transitionend', onEnd);
      });
    },
    { rootMargin: '0px 0px -10% 0px' },
  );

  elements.forEach((el) => observer.observe(el));
}

export function initReveal() {
  if (!('IntersectionObserver' in window)) {
    return;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  const elements = [...document.querySelectorAll(TARGETS)];
  if (elements.length === 0) {
    return;
  }

  // JS が動くときだけ非表示にする（JS 無効時は最初から表示）
  elements.forEach((el) => el.classList.add('c-reveal'));

  // ローディング画面があれば、消え始めてから監視を始める
  if (document.querySelector('.js-loading')) {
    document.addEventListener(LOADED_EVENT, () => observe(elements), { once: true });
    return;
  }

  observe(elements);
}
